import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Children, cloneElement, isValidElement } from 'react';
import { useAppSelector } from '../../../reducers';
import { isUngatedForInbound25Selector } from '../../../selectors/GatingSelectors';
import { getInbound25CopyChangeKey } from '../../../utils/copyChangeUtils';

/**
 * @internal
 * Copies and modifies the message prop of child components, i.e. FormattedMessage, FormattedJSXMessage, etc.
 *
 * @param children - The child components to modify.
 * @param messageModifier - A function that modifies the message key.
 * @returns The child components where the `message` prop is modified
 */
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export function CopyChange({
  children,
  messageModifier = key => key
}) {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Children.map(children, child => {
      if ( /*#__PURE__*/isValidElement(child) && (child.type === FormattedMessage || child.type === FormattedJSXMessage || child.type === FormattedHTMLMessage || child.type === FormattedReactMessage || 'message' in child.props && typeof child.props.message === 'string')) {
        const newProps = Object.assign({}, child.props, {
          message: messageModifier(child.props.message)
        });
        return /*#__PURE__*/cloneElement(child, newProps);
      }
      return child;
    })
  });
}
export function Inbound25CopyChange(props) {
  const isUngated = useAppSelector(isUngatedForInbound25Selector);
  return /*#__PURE__*/_jsx(CopyChange, Object.assign({}, props, {
    messageModifier: key => isUngated ? getInbound25CopyChangeKey(key) : key
  }));
}